<template>
  <div>
    <div class="wrapper">
      <div class="animated fadeIn">
        <b-form @submit.prevent="addItem">
          <b-row>
            <b-col cols="12" class="mb-3">
              <b-button variant="primary" @click="$router.go(-1)" class="pull-left">Terug</b-button>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <b-card>
                <template slot="header">
                  Actie inplannen
                </template>
                <b-row>
                  <b-col cols="12" md="6">
                    <b-row>
                      <b-col>
                        <h5>Basisgegevens</h5>
                        <hr>
                        <b-form-group label="Naam actie">
                          <b-form-input type="text" required v-model="item.name"></b-form-input>
                        </b-form-group>
                        <b-form-group label="Type">
                          <b-form-select :options="actionTypes" required v-model="item.type"></b-form-select>
                        </b-form-group>
                        <b-form-group label="Boodschap aan vrijwilligers">
                          <b-textarea rows="3" required v-model="item.introduction"></b-textarea>
                        </b-form-group>
                        <b-form-group label="Datum en tijd">
                          <datetime v-model="item.datetime" :minute-step="15" type="datetime"></datetime>
                        </b-form-group>
                        <b-form-group label="Startpunt (verzamellocatie)">
                          <b-form-input type="text" required v-model="input"/>
                          <b-list-group v-if="showList && suggestions">
                            <b-list-group-item
                              v-for="(suggestion, key) in suggestions.features"
                              :key="key"
                              @click="setPlace(suggestion)">
                                {{ transformSuggestion(suggestion) }}
                            </b-list-group-item>
                          </b-list-group>
                        </b-form-group>
                        <b-form-group label="Gemeente">
                          <b-form-select :options="municipalityOptions" required v-model="item.municipality_id"></b-form-select>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-col>
                  <b-col cols="12" md="6">
                    <b-row>
                      <b-col>
                        <h5>Overig</h5>
                        <hr>
                        <b-form-group label="Campagne">
                          <b-form-select :options="questionnaireOptions" required v-model="item.questionnaire_id"></b-form-select>
                        </b-form-group>
                        <b-form-group label="Doelstelling aantal gesprekken per deelnemer" hidden>
                          <b-form-input type="number" required v-model="item.participant_target"></b-form-input>
                        </b-form-group>
                        <hr>
                        <p><em>Let op! Bij het aanmaken van een canvasactie wordt meteen een notificatie aan alle vrijwilligers gestuurd.</em></p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <template slot="footer">
                    <b-button type="submit" variant="success" class="pull-right" :disabled="saveButtonDisabled">Toevoegen</b-button>
                </template>
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </div>
    </div>
  </div>
</template>
<script>
  import { getData, addData, getMapboxPlaces } from '@/api';
  import { Datetime } from 'vue-datetime';

  export default {
    name: 'campaign-action',
    components: {Datetime},
    props: ['id'],
    data() {
      return {
        item: {
          name: '',
          type: '',
          introduction: '',
          address: [],
          municipality_id: null,
          questionnaire_id: null,
          datetime: null,
          participant_target: 10,
        },
        actionTypes: [
          {
            text: 'Langs de deuren',
            value: 'door-to-door'
          },
          {
            text: 'In gesprek op 1 plek',
            value: 'fixed-location'
          },
        ],
        suggestions: undefined,
        place: [],
        placeName: '',
        municipalityOptions: [],
        questionnaireOptions: [],
        saveButtonDisabled: false,
        timeout: null,
        showList: false
      };
    },
    computed: {
      input: {
        get() {
          return this.placeName;
        },
        set(val) {
          if (this.timeout) {
            clearTimeout(this.timeout);
          }
          this.timeout = setTimeout(async () => {
            this.suggestions = await getMapboxPlaces(val);
            this.showList = true;
          }, 500);
        }
      }
    },
    methods: {
      setPlace(place) {
        this.place = place;
        this.placeName = this.transformSuggestion(place);
        this.showList = false;
      },
      transformSuggestion(suggestion) {
        const street = suggestion.text_NL;
        const houseNumber = suggestion.address || '';
        let postcode = '';
        let city = '';

        suggestion.context.map((value) => {
          if (value.id.includes('postcode')) {
            postcode = value.text_NL;
          }

          if (value.id.includes('place')) {
            city = value.text_NL;
          }
        });

        return houseNumber ? `${street} ${houseNumber}, ${postcode} ${city}` : `${street}, ${postcode} ${city}`;
      },
      async getMunicipalityOptions() {
        this.municipalityOptions = await getData('municipalities').then(
          (response) => response.data.data
        );
      },
      async getQuestionnaireOptions() {
        this.questionnaireOptions = await getData('questionnaires?options=1').then(
          (response) => response.data.data
        );
      },
      async addItem() {
        if(this.suggestions === undefined) {
          alert('Je moet een startpunt kiezen om de actie aan te kunnen maken');
          return false;
        }
        this.saveButtonDisabled = true;
        const [lng, lat] = this.place.geometry.coordinates;
        const request = await addData(
          'campaign-actions',
          {
            name: this.item.name,
            type: this.item.type,
            introduction: this.item.introduction,
            address: this.placeName,
            municipality_id: this.item.municipality_id,
            latitude: lat,
            longitude: lng,
            datetime: this.item.datetime,
            questionnaire_id: this.item.questionnaire_id,
            participant_target: this.item.participant_target,
          }
        );
        if (request.status === 201) {
          this.$router.push({ name: 'campaign-actions.view', params: { id: request.data.data.id } });
        } else {
          this.saveButtonDisabled = false;
        }
      },
    },
    beforeMount() {
      this.getMunicipalityOptions();
      this.getQuestionnaireOptions();
    },
  };

</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
